import {
  colors,
  colorTokens,
  overlayColors,
  semanticColors,
  thematicColors,
} from '../constants/colors';
import { landingTypography, typography } from '../constants/typography';

export const theme = {
  colors,
  semanticColors,
  thematicColors,
  overlayColors,
  typography,
  landingTypography,
  colorTokens,
} as const;
